import type { Request, Response } from 'express';
import type { History } from 'history';

import type { ApiClient } from '@travel/api-client';

import rootReducer from './rootReducer';

import { configureStore } from '@reduxjs/toolkit';

export default function createAppStore({
  preloadedState,
  history,
  req,
  res,
  apiClient,
}: {
  preloadedState?: any;
  history?: History;
  req?: Request;
  res?: Response;
  apiClient?: ApiClient;
}) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { history, req, res, apiClient },
        },
        serializableCheck: false,
      }),
  });
}
